export default __webpack_public_path__ + "static/media/grafik-helfen-sie-mit_fr.02fce437.svg";